import { TheMask } from 'vue-the-mask'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'

export default {
  TheMask,
  VueCtkDateTimePicker
}



// WEBPACK FOOTER //
// ./src/app/tenant/parking/resources/components.js